module.exports = __webpack_public_path__ + "img/04.9156676f.png";